document.addEventListener("DOMContentLoaded", () => {
    // Handle generic GTM browser events emitted from livewire components...
    document.addEventListener("gmt", (event) => {
        if (typeof window['google_tag_manager'] !== 'undefined') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({...event.detail});
        }
    });
});
